export enum CloudExceptionEnum {
    fileCopy = 'FILE_COPY',             // You can not copy file to this path.
    fileDelete = 'FILE_DELETE',         // Error occurs during deleting file
    fileMove = 'FILE_MOVE',             // You can not move file to this path.
    fileRetrieval = 'FILE_RETRIEVAL',   // Execute error
    fileUpload = 'FILE_UPLOAD'          // Error occurs during uploading file
}

export class CloudException {
    message: CloudExceptionEnum | string;

    constructor(message: CloudExceptionEnum | string) {
        this.message = message;
    }

    toString(): string {
        return `CLOUDERRORS.${this.message}`;
    }
}
